import React from 'react';
import './AdBanner.css';
import adBannerBg from '../../assets/images/adBanner.png';
import degreeHatIcon from '../../assets/icons/degreeHat.svg';
import Button from '../Button/Button';

const AdBanner = () => {
  return (
    <section className="ad-banner-wrapper">
      <div className="ad-banner-section">
        <div className="ad-banner-bg-layer">
          <img src={adBannerBg} alt="Background" className="ad-banner-bg-img" />
          <div className="ad-banner-overlay"></div>
        </div>
        
        <div className="ad-banner-content">
          <div className="ad-icon-wrapper">
            <img src={degreeHatIcon} alt="Degree" className="ad-icon" />
          </div>
          
          <div className="ad-text">
            <h3>Transform Your Future</h3>
            <p>Join 50,000+ Students Building Tomorrow's World</p>
          </div>
          
          <div className="ad-cta">
            <Button variant="orange" showArrow={true}>
              Apply Now
            </Button>
            <span className="ad-sub-cta">Applications Open for Fall 2026</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AdBanner;
